module.exports = __webpack_public_path__ + "img/257-5265de.png";